
  import { defineComponent } from 'vue';

  import text from '@/common/mixins/text';
  import Tooltip from '@/common/ui/Tooltip.vue';

  export default defineComponent({
    name: 'IndicatorCard',
    mixins: [text],
    emits: ['click'],
    components: { Tooltip },
    props: {
      title: {
        type: String,
        default: '',
      },
      titleStyle: {
        type: Object,
        default: () => ({}),
      },
      value: {
        type: Number,
        default: null,
      },
      valueMeasure: {
        type: String,
        default: '',
      },
      percentValue: {
        type: Number,
        default: null,
      },
      isPercent: {
        type: Boolean,
        default: false,
      },
      year: {
        type: Number,
        default: null,
      },
      tooltipText: {
        type: String,
        default: '',
      },
      place: {
        type: Number,
        default: 0,
      },
      mod: {
        type: String,
        default: '',
        validator(val: string) {
          return ['inverted-card'].includes(val);
        },
      },
      minHeight: {
        type: Number,
        default: 160,
      },
      modContentTooltip: {
        type: String,
        default: 'width-600',
      },
    },
    computed: {
      cardStyle() {
        return {
          minHeight: `${this.minHeight}px`,
        };
      },
      resolveValueFormat(): string | number {
        if (this.value == null) {
          return '-';
        }
        return this.value.toString().includes('.') ? this.formatNumber(this.value, 1, '', ',') : this.value;
      },
      percentDirection(): string {
        return this.percentValue > 0 ? 'text-green' : 'text-red';
      },
      resolvePercentValue(): string {
        const sign = this.percentValue > 0 ? '+' : '';
        return this.isPercent ? `${sign}${this.formatNumber(this.percentValue, 1)}%` : `${sign}${this.percentValue}`;
      },
    },
    methods: {
      handleCardClick() {
        this.$emit('click');
      },
    },
  });
